import { PixelIcon } from "./PixelArt";
import { goldCoinTier } from "../../shared/bounty.ts";

/** The amount remains readable when decorative art is unavailable. */
export function Gold({ amount, prefix = "" }: { amount: number; prefix?: string }) {
  return <span class="gold"><PixelIcon name="coin" /><span class="gold-value">{prefix}{amount.toLocaleString()}</span>{" "}<span class="gold-unit">gold</span></span>;
}

/**
 * Wood (docs/upgrades.md), the currency upgrades are built from: the amount beside a small pixel
 * log, and the word "wood", so it is never labelled by the icon alone.
 */
export function Wood({ amount, prefix = "" }: { amount: number; prefix?: string }) {
  return <span class="wood"><PixelIcon name="wood" /><span class="wood-value">{prefix}{amount.toLocaleString("en-US")}</span>{" "}<span class="wood-unit">wood</span></span>;
}

/**
 * Coins instead of a number, for task cards: one coin for a little gold, two overlapping for some,
 * three for a lot (shared/bounty.ts goldCoinTier). The exact amount lives on the task screen.
 */
const COIN_LABELS = { 1: "Pays a little gold", 2: "Pays some gold", 3: "Pays a lot of gold" } as const;

export function Coins({ total }: { total: number }) {
  const tier = goldCoinTier(total);
  return (
    <span class={`coins coins-${tier}`} role="img" aria-label={COIN_LABELS[tier]}>
      {Array.from({ length: tier }, (_, i) => (
        <img key={i} class="coin" src="/ui/coin@3x.png" width={12} height={12} alt="" aria-hidden="true" />
      ))}
    </span>
  );
}
